import { gql } from "@apollo/client";
import { get } from 'lodash';
import React from 'react';
import StdQuery from '../StdQuery.js';
import { parsePhoneNumber } from "libphonenumber-js";
import Untranslatable from "../../Untranslatable.js";
import useStdQuery from "components/data/hooks/useStdQuery.js";

const customerSelector = "session.customer";
const contactSelector = `${customerSelector}.contact`;

export const GET_FULLNAME = gql`query FullName {
	session {
		customer {
			contact {
				name {
					firstName
					middleInitial
					lastName
				}
				id
			}
			id
		}
		id
	}
}`;

const GET_CONTACT_ID = gql`query ContactIds {
	session {
		id
		customer {
			id
			contact {
				id
			}
		}
	}
}`;

export const useCustomerName = () => {
	const { data: customerNameData } = useStdQuery(GET_FULLNAME);
	return customerNameData?.session.customer?.contact.name ?? null;
};

export const useContactId = () => {
	const queryResult = useStdQuery(GET_CONTACT_ID);

	return {
		contactId: queryResult?.data?.session.customer?.contact.id,
		queryResult,
	 };
};


export const FullName = ({ initials = false }) => {
	const name = useCustomerName();

	if (!name) {
		return null;
	}

	const {
		firstName = '',
		middleInitial = '',
		lastName = '',
	} = name;

	return <Untranslatable elementType="span">
		{initials
			? get(firstName, '0', '') + get(lastName, '0', '')
			: `${firstName} ${middleInitial && middleInitial + ' '}${lastName}`
		}
	</Untranslatable>;
};

export const GET_FIRSTNAME = gql`query FirstName {
	session {
		customer {
			contact {
				name {
					firstName
				}
				id
			}
			id
		}
		id
	}
}`;

export class FirstName extends React.Component {
	render() {
		return (
			<StdQuery query={GET_FIRSTNAME}>
				{({ data }) =>
					<Untranslatable elementType="span">
						{get(data, contactSelector + ".name.firstName")}
					</Untranslatable>}
			</StdQuery>
		);
	}
}

export const GET_EMAIL = gql`query Email {
	session {
		customer {
			contact {
				email
				id
			}
			id
		}
		id
	}
}`;

export class Email extends React.Component {
	render() {
		return (
			<StdQuery query={GET_EMAIL}>
				{({ data }) =>
					<Untranslatable elementType="span">{get(data, contactSelector + ".email")}</Untranslatable>}
			</StdQuery>
		);
	}
}

export const GET_USERNAME = gql`query GET_USERNAME {
	session {
		customer {
			contact {
				username
				id
			}
			id
		}
		id
	}
}`;


export const GET_CUSTOMER_CONTACT_IDS = gql`query GET_CUSTOMER_CONTACT_IDS {
	session {
		customer {
			contact {
				id
			}
			id
		}
		transitAccountId
		id
	}
}`;
export const GetCustomerContactIds = (props) => (
	<StdQuery query={GET_CUSTOMER_CONTACT_IDS}>
		{(data) => props.children({
			...data,
			customerId: get(data.data, customerSelector + ".id"),
			contactId: get(data.data, contactSelector + ".id"),
			transitAccountId: get(data.data, 'session.transitAccountId'),
		})}
	</StdQuery>
);


export const PIN_QUERY = gql`query PIN_QUERY {
	session {
		customer {
			contact {
				pin
				id
			}
			id
		}
		id
	}
}`;

export class Pin extends React.Component {
	render() {
		return (
			<StdQuery query={PIN_QUERY}>
				{({ data }) => get(data, contactSelector + ".pin")}
			</StdQuery>
		);
	}
}

export const GET_SYSTEMGENPASSWORD_SETTING = gql`query systemGenPassword {
	session {
		customer {
			contact {
				systemGenPassword
				id
			}
			id
		}
		id
	}
}`;

export const PIN_AND_SYSTEMGENPASSWORD_QUERY = gql`query PIN_AND_SYSTEMGENPASSWORD_QUERY {
	session {
		customer {
			contact {
				pin
				systemGenPassword
				id
			}
			id
		}
		id
	}
}`;

export const FILTER_DATE_RANGE_QUERY = gql`
	query FilterDateRangeQuery (
		$startDateTime: String
		$endDateTime: String
		$specificDate: String
		$paymentMethod: String
		$retrievalRefNbr: String
		$bankChargeStatusFilter: Int
	){
		ridesChargesQ (
			startDateTime: $startDateTime
			endDateTime: $endDateTime
			specificDate: $specificDate
			paymentMethod: $paymentMethod
			retrievalRefNbr: $retrievalRefNbr
			bankChargeStatusFilter: $bankChargeStatusFilter
		){
			lineItem {
				paymentId
				openedDateTime
				settledDateTime
				requestedAmount
				authorizedAmount
				maxAggregationAmount
				totalUsedAmount
				remainingAmount
				retrievalRefNbr
				response
				responseDescription
				status
				statusDescription
				isCorrectable
				numberOfTrips
				bankcardCharged {
					cardBrand
					maskedPan
					expirationMonth
					expirationYear
				}
			}
			transitId
			subsystem
		}
	}
`;


export const formatPhoneNumberInternational = (phoneStr, country) => {
	const phoneNumber = parsePhoneNumber(phoneStr, country);
	return phoneNumber.formatInternational();
};

export const GET_PHONE = gql`query Phone {
	session {
		customer {
			contact {
				phone {
					number
					type
					country
				}
				id
			}
			id
		}
		id
	}
}`;

export class Phone extends React.Component {
	render() {
		return (
			<StdQuery
				query={GET_PHONE}
			>
				{({ data }) => {
					const phone = formatPhoneNumberInternational(
						get(data, contactSelector + ".phone[0].number", ""),
						get(data, contactSelector + ".phone[0].country", "US"),
					);
					return phone;
				}}
			</StdQuery>
		);
	}
}


export const GET_SUMMARY = gql`
	query getMonthlySummary(
		$startDateTime: String
		$endDateTime: String
		$specificDate: String
		$paymentMethod: String
	){
		monthlySummary(
			startDateTime: $startDateTime
			endDateTime: $endDateTime
			specificDate: $specificDate
			paymentMethod: $paymentMethod
		){
			id
			spent
			rides
			summaryDateIso
		}
	}
`;

export class Phone1withType extends React.Component {
	render() {
		return (
			<StdQuery
				query={GET_PHONE}
			>
				{({ data }) => {
					const phone1 = formatPhoneNumberInternational(
						get(data, contactSelector + ".phone[0].number", ""),
						get(data, contactSelector + ".phone[0].country", "US"),
					);
					const phoneType = get(data, contactSelector + ".phone[0].type", "");
					return `${phone1} ${phoneType}`;
				}}
			</StdQuery>
		);
	}
}

export const PhoneWithType = ({ children }) => {
	return (
		<StdQuery query={GET_PHONE}>
			{({ data }) => {
				const phones = get(data, contactSelector + ".phone", []);
				// filter out deleted phones which are returned from BO as a string like '+100'
				return children(phones);
			}}
		</StdQuery>
	);
};

export const GET_SESSION_TRANSIT_ACCOUNT_ID = gql`query TransitAccountId {
	session {
		id
		transitAccountId
	}
}`;
